// Códigos de compensação (COMPE) dos bancos mais comuns
const BANKS: Record<string, string> = {
  "001": "Banco do Brasil",
  "033": "Santander",
  "077": "Inter",
  "104": "Caixa Econômica Federal",
  "208": "BTG Pactual",
  "212": "Banco Original",
  "237": "Bradesco",
  "260": "Nubank",
  "290": "PagBank",
  "323": "Mercado Pago",
  "336": "C6 Bank",
  "341": "Itaú",
  "380": "PicPay",
  "748": "Sicredi",
  "756": "Sicoob",
};

export const getBankName = (code?: string | null): string => {
  if (!code) return "Banco não informado";
  const key = code.padStart(3, "0");
  return BANKS[key] ? `${BANKS[key]} (${key})` : `Banco ${key}`;
};
